window.notificationHide = function(button) {

    let self = this;

    const scriptUrls = [
        'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/gsap.min.js',
        'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/ScrollTrigger.min.js',
    ];

    //chybí zde promise, zda jsou scripty stažený nebo ne.
    window.initPackages(scriptUrls);

    let notificationBar = document.querySelector('.js-notification');
    let notificationBarHeight = parseInt(window.getComputedStyle(notificationBar).height, 10);
    let mainNode = document.querySelector('main');
    let mainMarginTop = parseInt(window.getComputedStyle(mainNode).marginTop, 10);
    mainMarginTop = (mainMarginTop - notificationBarHeight);

    gsap.to(notificationBar, {duration: 0.3, autoAlpha:0, opacity: '0', onComplete:function(){
        notificationBar.remove();
        //posunutí main o hodnotu notificationBaru
        mainNode.style.marginTop = mainMarginTop + "px";
        calcMargin();
    }});
};

const calcMargin = () => {
    document.querySelector('main').style.marginTop = document.querySelector('.js-header').offsetHeight + 'px';
};


